<template>
  <div></div>
</template>

<script>
window.location.replace('https://web.aerologixmaps.com')
</script>

<style scoped lang="scss"></style>
